// extracted by mini-css-extract-plugin
export default {"container":"LabelCommon_container__VU5nH","organization":"LabelCommon_organization__93slf","rank":"LabelCommon_rank__t3RTL","crown":"LabelCommon_crown__U0wPC"};